import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useModalContext } from '@providers/ModalProvider';
import { useState } from 'react';
import { IconButtonClean } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonClean';
import LeftIcon from '@components/icons/ArrowLeft.svg';
import RightIcon from '@components/icons/ArrowRight.svg';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  onCancel: () => void;
  month: number;
  year: number;
  setMonth: (v: number) => void;
  setYear: (v: number) => void;
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MonthPickerModal = ({ onCancel, month, year, setMonth, setYear }: TProps) => {
  const { closeModal } = useModalContext();
  const [innerMonth, setInnerMonth] = useState(month);
  const [innerYear, setInnerYear] = useState(year);

  const onSave = () => {
    setMonth(innerMonth);
    setYear(innerYear);
    closeModal();
  };

  return (
    <Wrapper>
      <ModalWrapper width="450px">
        <div className="year">
          <IconButtonClean
            type="button"
            title="Previous year"
            className="year-prev"
            onClick={() => setInnerYear(innerYear - 1)}
          >
            <LeftIcon />
          </IconButtonClean>
          <div className="year-current">{innerYear}</div>
          <IconButtonClean
            type="button"
            title="Next year"
            className="year-next"
            onClick={() => setInnerYear(innerYear + 1)}
          >
            <RightIcon />
          </IconButtonClean>
        </div>

        <div className="months">
          {months.map((month, index) => (
            <div
              key={month}
              className={`month ${index === innerMonth ? 'active' : ''}`}
              onClick={() => setInnerMonth(index)}
            >
              {month}
            </div>
          ))}
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={onSave}>Apply</Button>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};
